import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { createContext, useCallback, useContext, useMemo, useState } from 'react';
import { StatsigClient } from '../statsig-client';
import { jsx as _jsx } from "react/jsx-runtime";
export const StatsigContext = /*#__PURE__*/createContext({
  statsigClient: new StatsigClient(),
  // without init it will return only falsy or default value. its required so that consumer does has to put a check for undefined
  statsigState: false
});
export function useStatsig() {
  const context = useContext(StatsigContext);
  if (context === undefined) {
    console.error('useStatsig must be used within a StatsigProvider');
  }
  return context.statsigClient;
}
export function withStatsig(Component) {
  return function StatsigComponent(props) {
    return /*#__PURE__*/_jsx(StatsigContext.Consumer, {
      children: _ref => {
        let {
          statsigClient
        } = _ref;
        return /*#__PURE__*/_jsx(Component, _objectSpread(_objectSpread({}, props), {}, {
          statsigClient: statsigClient
        }));
      }
    });
  };
}
export const StatsigProvider = _ref2 => {
  let {
    children,
    statsigClient
  } = _ref2;
  const [statsigContextState, setStatsigContextState] = useState(false);
  const refreshStatsig = () => setStatsigContextState(prevState => !prevState);
  const contextValue = useMemo(() => ({
    statsigClient,
    statsigState: statsigContextState,
    refreshStatsig
  }), [statsigClient, statsigContextState]);
  return /*#__PURE__*/_jsx(StatsigContext.Provider, {
    value: contextValue,
    children: children
  });
};
export const useSetStatsigUser = () => {
  const {
    refreshStatsig,
    statsigClient
  } = useContext(StatsigContext);
  return async identifiers => {
    await statsigClient.updateIdentifiers(identifiers);
    if (refreshStatsig) {
      refreshStatsig();
    }
  };
};
export const useStatsigWithUpdatedUser = () => {
  const {
    statsigClient,
    statsigState
  } = useContext(StatsigContext);
  return {
    enableOneClickAppInstall: useCallback(() => {
      return statsigClient.enableOneClickAppInstall();
    }, [statsigState, statsigClient]),
    enableTwoClickAppInstall: useCallback(() => {
      return statsigClient.enableTwoClickAppInstall();
    }, [statsigState, statsigClient])
  };
};